export default "__VITE_ASSET__C4YI8MeI__"